<template>
  <div class="app-container">
    <div class="filter-container">
      <el-date-picker
        v-model="queryDate"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        class="filter-item"
        style="margin-right: 10px"
      ></el-date-picker>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
      <el-button
        :loading="downloadLoading"
        class="filter-item"
        type="primary"
        icon="el-icon-download"
        @click="handleDownload"
       >导出
      </el-button>
      
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      ref="dataTable"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
       :max-height="clientHeight" 
      size="mini"
    >
      <el-table-column align="center" label="ID" width="100">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>
      <el-table-column align="center" label="客户代号" width="80">
        <template slot-scope="scope">{{ scope.row.custid }}</template>
      </el-table-column>
      <el-table-column align="center" label="客户名称" width="140">
        <template slot-scope="scope">{{ scope.row.custname }}</template>
      </el-table-column>
      <el-table-column align="center" label="单据类型" width="80">
        <template slot-scope="scope">{{ scope.row.billtypename }}</template>
      </el-table-column>
      <el-table-column label="单据日期" align="center" width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.billdate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="品种代号" align="center" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.artid }}</template>
      </el-table-column>
      <el-table-column label="品种名称" align="center" width="120" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column label="规格" align="center" width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.spec }}</template>
      </el-table-column>
      <el-table-column label="厂家" align="center" width="120" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.factory }}</template>
      </el-table-column>
      <el-table-column label="单位" align="center" width="70" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.unit }}</template>
      </el-table-column>
      <el-table-column label="批号" align="center" width="90">
        <template slot-scope="scope">{{ scope.row.serial }}</template>
      </el-table-column>
      <el-table-column label="数量" align="center" width="90" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.total }}</template>
      </el-table-column>
      <el-table-column label="价格" align="center" width="100">
        <template slot-scope="scope">{{ scope.row.price }}</template>
      </el-table-column>
      
    </el-table>

    

     <!--分页-->
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    >
    </pagination>
  </div>
</template>

<script>
import { getFlowImport2,getFlowExport2,selectCustList,saveFlow,deleteFlow } from '@/api/flow'
import Pagination from '@/components/Pagination'

export default {
  name: 'ProductInfo',

   components: {
     Pagination
   },

  data() {
    return {
      clientHeight: '800',
      queryDate: [],
      list: null,
       total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        asc: false,
        startDate:'',
        endDate:''
      },
      code: '',
      artid: '',
      listLoading: false,
      downloadLoading: false,
      ImportdialogVisible:false, //"导入"对话框是否可见
      AdddialogVisible:false,
      ImportTitle:'导入Excel', //"导入"对话框的标题
      limitNum: 1,//导入文件的个数
      form: {    //"导入"表单绑定file，并初始化
          file: ''
        },
      addform:{
        custid:'',
        custstr:'',
        billtypeid:'',
        billdatestr:'',
        artid:'',
        serial:'',
        total:'',
        price:''
      },
       options: [{
          value: '2101',
          label: '销售出库单'
        }, {
          value: '2201',
          label: '销售退货单'
        }],
         arts: [{
          value: '46196',
          label: '速效救心丸'
        }, {
          value: '116827',
          label: '#京万红软膏'
        },{
          value:'184272',
          label:'癃清片'
        }],
      fileList: [],//"导入"文件列表
    }
  },

  created() {
    this.getList();
    this.initHeight()
  },

  mounted() {
    window.addEventListener('resize', this.initHeight)
  },

  methods: {
    initHeight() {
      this.clientHeight = document.documentElement.clientHeight - 240
    },
    querySearch(queryString, cb){
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          if(!queryString){
            return;
          }
          selectCustList(queryString)
            .then(response => {
              cb(response.data);
            })
            .catch(() => {
            
            })
        }, 1000 * Math.random());

    },
    handleSelect(item) {
        this.addform.custid=item.id;
    },
    getList() {
      this.list = []
      let [start, end] = this.queryDate || []
      this.listQuery.startDate = start
      this.listQuery.endDate = end
        this.listLoading = true
        getFlowImport2(this.listQuery)
          .then(response => {
            this.list = response.data.items
            this.total = response.data.total
            this.listLoading = false
            this.listLoading = false
          })
          .catch(() => {
            this.list = []
            this.listLoading = false
          })
      
    },
    // 新增按钮跳转到新增采购单
    handleCreate() {
      this.AdddialogVisible = true;
    },
    importBook(){ //弹出导入对话框

      let self = this;

      self.ImportdialogVisible = true;

    },

    // 文件超出个数限制时的钩子

    exceedFile(files, fileList) {

          this.$notify.warning({

          title: '警告',

          message: `只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`

      });

    },

    // 文件状态改变时的钩子

    fileChange(file, fileList) {

        console.log('change')

        console.log(file)

        this.form.file = file.raw

        console.log(this.form.file)

        console.log(fileList)

      },

    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传

    beforeUploadFile(file) {

        console.log('before upload')

        console.log(file)

      // let extension = file.name.substring(file.name.lastIndexOf('.')+1); //获取上传文件的扩展名

        //console.log("文件扩展名为:"+extension);

        let size = file.size / 1024 / 1024; //设置上传文件的大小

        const isXLSX = file.name.split(".")[1] === 'xlsx'; //获取上传文件的扩展名

        if(!isXLSX){

            this.$notify.warning({

            title: '警告',

            message: `只能上传Excel2017（即后缀是.xlsx）的文件`

          });

          

        }

        if(size > 10) {

            this.$notify.warning({

            title: '警告',

            message: `文件大小不得超过10M`

          });

          

        }

        

      },

      // 文件上传成功时的钩子

      handleSuccess(res, file, fileList) {

          let self = this;

          this.$notify.success({

          title: '成功',

          message: `文件导入成功`

          });

          this.getList();

          self.ImportdialogVisible = false;  

      },

      // 文件上传失败时的钩子

      handleError(err, file, fileList) {

          this.$notify.error({

          title: '错误',

          message: `文件导入失败`

          });

      },

      submitUpload(){

          let self = this;

          if(self.form.file == ''){

            this.$notify.error({

              title: '错误',

              message: `请选择要导入的文件`

            });

            return;

          }

          self.$refs.uploadExcel.submit();

      },
    // 格式化数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j]
        })
      )
    },
    // 导出事件
    handleDownload() {
      this.downloadLoading = true
      getFlowExport2(this.listQuery).then(response => {
        this.allList = response.data
        import('@/vendor/Export2Excel')
          .then(excel => {
            const tHeader = [
              '客户代号',
              '客户名称',
              '单据类型',
              '单据日期',
              '品种代号',
              '品种名称',
              '规格',
              '厂家',
              '单位',
              '批号',
              '数量',
              '价格'
            ]
            const filterVal = [
              'custid',
              'custname',
              'billtypename',
              'billdate',
              'artid',
              'name',
              'spec',
              'factory',
              'unit',
              'serial',
              'total',
              'price',
            ]
            const data = this.formatJson(filterVal, this.allList)
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: '商品流向'
            })
            this.downloadLoading = false
          })
          .catch(() => {
            this.downloadLoading = false
          })
      })
    }
   }
}
</script>
